import * as React from 'react';

import * as styles from '../../../Styles/svgShadow.css';

const IconMute = () => (
    <svg viewBox="0 0 100 100" className={styles.svgShadow}>
        <polygon points="71.498,49.827 58.478,62.847 62.45,66.82 75.47,53.8 88.49,66.82
        92.462,62.847 79.442,49.827 92.462,36.808 88.49,32.835 75.47,45.855 62.45,32.835 58.478,36.808"/>
        <polygon points="49.115,23.473 49.115,76.527 28.518,61.547 13.538,61.547 13.538,38.453
        28.518,38.453"/>
    </svg>
);

export default IconMute;